import { ChangeDetectorRef, Component } from "@angular/core";
import { StoreService } from "../../services/store.service";
import { Router } from "@angular/router";
import { GlobalService } from "../../services/global.service";
import { map, Subscription } from "rxjs";
@Component({
    selector: "web-header",
    templateUrl: "./header.component.html",
    styleUrls: ["./header.component.scss"],
})
export class HeaderComponent {
    customerName: string = "";
    subscriptions: Subscription[] = [];
    showLogout: any[] = ["/loan/apply"];
    notShowBack: any[] = ["/loan/apply"];
    showProfile: string[] = ["/auth"];
    showLogoutButton: boolean = false;
    showBackButton: boolean = false;
    showProfilePic: boolean = false;
    greeting: string = "";
    customerProfile: string = "assets/svg/icons/user-placeholder.svg";
    isMobile: boolean = false;
    // unreadableCount: number = 0;
    // rewardWalletBalance: number = 0;
    constructor(
        private storageService: StoreService,
        public globalService: GlobalService,
        private router: Router,
        private cdr: ChangeDetectorRef
    ) {
        // this.rewardWalletBalance = parseInt(this.storeService.get("rewardWalletBalance") || "0");

        this.getGreeting();

        if (this.showLogout.includes(this.router.url)) {
            this.showLogoutButton = true;
        } else {
            this.showLogoutButton = false;
        }
        if (!this.notShowBack.includes(this.router.url)) {
            this.showBackButton = true;
        } else {
            this.showBackButton = false;
        }

        if (this.showProfile.some((profile) => this.router.url.startsWith(profile))) {
            this.showProfilePic = false;
        } else {
            this.showProfilePic = true;
        }

        // this.unreadableCount = parseInt(this.storeService.get("unreadNotification") || "0");

        // this.globalService.isReadNotification.subscribe(() => {
        //     this.unreadableCount = parseInt(this.storeService.get("unreadNotification") || "0");
        // });

        this.globalService.customerDetails
            .pipe(
                map((details) => {
                    if (!details || typeof details !== "object" || Object.keys(details).length === 0) {
                        details = this.storageService.get("customerDetails");
                        details = typeof details === "string" ? JSON.parse(details) : details;
                    }

                    this.customerProfile =
                        details && details?.customerProfile && details?.customerProfile != ""
                            ? details?.customerProfile
                            : "assets/svg/icons/user-placeholder.svg";
                    this.customerName = details && details.nickName ? details?.nickName.toString() : "";
                    this.customerName =
                        this.customerName && this.customerName.trim() !== "" ? `Hi, ${this.customerName}` : "Hi there";
                })
            )
            .subscribe();
    }

    ngAfterViewChecked() {
        this.detectMobile();
    }

    detectMobile(): void {
        const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(
            navigator.userAgent
        );
        // Only update if value changed to avoid infinite loops
        if (this.isMobile !== mobile) {
            this.isMobile = mobile;
            this.cdr.detectChanges();
        }
    }

    getGreeting() {
        const hour = new Date().getHours();
        if (hour < 12) {
            this.greeting = "Good morning";
        } else if (hour < 18) {
            this.greeting = "Good afternoon";
        } else {
            this.greeting = "Good evening";
        }
    }

    openProfile() {
        this.router.navigate(["/profile"]);
    }

    redirect: any = {
        "/loan/timeline": "/loan/apply",
        "/loan/apply": "/loan/apply",
        "/loan/re-pay": "/loan/apply",
        "/loan/kyc/pan-kyc": "/loan/apply",
        "/loan/in-verification": "/loan/apply",
        "/loan/criteria-mismatch": "/loan/apply",
        "/loan/employment": "/loan",
        "/loan/employment/company-search": "/loan",
        "/loan/employment/company-phone": "/loan/employment/company-address",
        "/loan/employment/company-address": "/loan/employment/company-search",
    };

    toggleSidebarForOpen() {
        this.globalService.sidebarToggle.next(true);
    }
}
